import axios from "axios";

const byDraftId = {};

const serverUrl = () => process.env.REACT_APP_SERVER_URL || "";

export const stashVoiceSaleIdentity = (draftId, patch) => {
  if (!draftId || !patch) return;
  byDraftId[draftId] = { ...(byDraftId[draftId] || {}), ...patch };
};

export const voiceSaleIdentity = (draftId) => byDraftId[draftId] || null;

export const postMemberIdentityDocument = async ({ memberId, file, url }) => {
  if (!memberId || (!file && !url)) {
    return { ok: false, message: "Upload the member identity document." };
  }
  const user = JSON.parse(
    localStorage.getItem("connectToFitGymPanelUser") || "{}"
  );
  const formData = new FormData();
  formData.append("member", memberId);
  formData.append("content", url || "");
  formData.append("attachmentSource", "ID");
  if (file) formData.append("file", file);
  try {
    const res = await axios.post(`${serverUrl()}member/document`, formData, {
      headers: { "x-auth": user.token },
    });
    const bodyStatus = Number(res && res.data && res.data.status);
    if (
      !res ||
      res.status < 200 ||
      res.status >= 300 ||
      (Number.isFinite(bodyStatus) && bodyStatus >= 400)
    ) {
      return {
        ok: false,
        message:
          (res && res.data && (res.data.message || res.data.error)) ||
          "Could not save the identity document.",
      };
    }
    return { ok: true };
  } catch (error) {
    const res = error && error.response;
    return {
      ok: false,
      message:
        (res && res.data && (res.data.message || res.data.error)) ||
        "Could not save the identity document.",
    };
  }
};

const fileFromUrl = async (url) => {
  if (!url || typeof fetch !== "function") return null;
  try {
    const res = await fetch(url);
    if (!res || !res.ok) return null;
    const blob = await res.blob();
    const name = String(url).split("/").pop() || "identity.jpg";
    return new File([blob], name, { type: blob.type || "image/jpeg" });
  } catch (error) {
    return null;
  }
};

export const persistStashedSaleIdentity = async (draft, memberId) => {
  const stashed = voiceSaleIdentity(draft && draft.id);
  const url =
    (draft && draft.fields && draft.fields.attachment) ||
    (stashed && stashed.url);
  let file = stashed && stashed.file;
  if (!file && url) file = await fileFromUrl(url);
  if (!url && !file) return { ok: true, skipped: true };
  if (!memberId) {
    return { ok: true, skipped: true };
  }
  if (stashed && stashed.uploadedFor === String(memberId)) {
    return { ok: true };
  }
  const uploaded = await postMemberIdentityDocument({
    memberId,
    file,
    url,
  });
  if (uploaded.ok) {
    stashVoiceSaleIdentity(draft.id, { uploadedFor: String(memberId), url });
  }
  return uploaded;
};
